import React, { useContext, useState } from "react";
import { Button, Input, Table, Tooltip } from "antd";
import { ScheduleOutlined } from "@ant-design/icons";
import _ from "lodash";
import { CustomerOrderInfo, UserInfo } from "../../../../context";
import MerchantEmployeeLayout from "../../../layout/MerchantEmployeeLayout";
import MerchantEmployeeToBillOutDetails from "./MerchantEmployeeToBillOutDetails";

const MerchantEmployeeToBillOut = () => {
  const [search, setSearch] = useState("");
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { merchantPayLaterList, rerunPayLater } = useContext(CustomerOrderInfo);

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Transaction Number",
      dataIndex: "transaction_id",
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      render: (text, record) => <p>{text}</p>,
    },
    {
      // title: dineTypeList && allowDineSetup ? "Location" : "Table Number",
      title: "Location",
      dataIndex: "table_no",
      render: (text, record) => <p>{text !== "Table #" ? text : ""}</p>,
    },
    {
      title: "Status",
      dataIndex: "service_category",
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            color:
              text === "dine"
                ? "green"
                : text === "pickup"
                ? "#aeaeae"
                : text === "delivery"
                ? "#b804c2"
                : "blue",
            fontWeight: "bold",
          }}
        >
          {text === "dine"
            ? "DINE"
            : text === "pickup"
            ? "PICK UP"
            : text === "delivery"
            ? "DELIVERY"
            : "TAKE OUT"}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 40,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 40 }}>
          <Tooltip title="Bill Out Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<ScheduleOutlined />}
              size="small"
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const searchable = merchantPayLaterList.data.filter((data) => {
    return (
      data.customer_name.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.transaction_id.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  return (
    <MerchantEmployeeLayout>
      <div style={{ overflowX: "auto" }}>
        <div style={{ marginBottom: 10 }}>
          <Input
            id="search"
            placeholder="Search transaction # or name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>

        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.transaction_id}
        />
      </div>

      {openDrawer && (
        <MerchantEmployeeToBillOutDetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          selectedData={selectedData}
        />
      )}
    </MerchantEmployeeLayout>
  );
};

export default MerchantEmployeeToBillOut;
